import axios from '@/plugins/axios'
import {ApiLogin, ApiRegister} from "@/const";
import TokenService from "@/services/TokenService";
import CookieService from "@/services/CookieService";

class AuthService {
    /**
     * Метод авторизации пользователей
     * @param data
     */
    login(data: any) : Promise<void> {
        return axios.post(ApiLogin, {
            login: data.login,
            password: data.password
        }).then(response => {
            if(response.data.status == false) {
                throw response.data
            }
            if(response.headers.authorization) {
                TokenService.setLocalAccessToken(response.headers.authorization)
            }
        }).catch(error => {
            throw error
        })
    }

    /**
     * Метод регистрации пользователей
     * @param data
     */
    register(data: any) : Promise<void> {
        return axios.post(ApiRegister, {
            login: data.login,
            password: data.password,
            guest_id: data.guest_id
        }).then(response => {
            if(response.data.status == false)
                throw response.data
        }).catch(error => {
            throw error
        })
    }

    /**
     * Метод выхода из аккаунта пользователей
     * @param data
     */
    /*
        NOTE!!

        Удаление токена JWT из localstorage, входит в реализацию метода
        выхода из аккаунта logout класса UserService
     */
    logout() : void {
        TokenService.removeLocalAccessToken()
        CookieService.eraseCookie('user')
    }
}

export default new AuthService()